import React, { Suspense, lazy } from "react";
import "./App.css";

import SiteShell        from "./components/SiteShell";
import MortgageLander    from "./pages/MortgageLander"; // eager - the whole public site

// Lazy-loaded utility routes - not part of the funnel critical path.
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const Privacy         = lazy(() => import("./pages/Legal").then(m => ({ default: m.Privacy })));
const Terms           = lazy(() => import("./pages/Legal").then(m => ({ default: m.Terms })));
const Cookies         = lazy(() => import("./pages/Legal").then(m => ({ default: m.Cookies })));

// Minimal fallback - matches site bg so there is no flash.
function PageShell() {
  return <div style={{ minHeight: "100vh", background: "#faf9f6" }} />;
}

// One page + three legal pages + admin, all reached by full page loads (footer links
// are plain anchors, the LID backdoor sets window.location.href, and Cloudflare Pages
// serves index.html for every path), so a router would be dead weight in the bundle.
const LEGAL = { "/privacy": Privacy, "/terms": Terms, "/cookies": Cookies };

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";

  // Admin - outside SiteShell, no header / footer.
  // Not linked anywhere. Only reachable by typing the LID sequence.
  if (path === "/admin") {
    return (
      <Suspense fallback={<PageShell />}>
        <AdminDashboard />
      </Suspense>
    );
  }

  // One page, one audience, one action. Every other path lands on the lander too.
  const Legal = LEGAL[path];
  return (
    <SiteShell>
      {Legal ? (
        <Suspense fallback={<PageShell />}>
          <Legal />
        </Suspense>
      ) : (
        <MortgageLander />
      )}
    </SiteShell>
  );
}
